import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

const initialState={
    deliveryList:[],
    selectedDelivery: null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchDelivery=createAsyncThunk('delivery/fetchDelivery', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/delivery/getDeliveries',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})
export const fetchDeliveryById=createAsyncThunk('delivery/fetchDeliveryById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/delivery/getDeliveryById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})
export const createDelivery=createAsyncThunk('delivery/createDelivery', async (delivery)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/delivery/createDelivery',
        {
            method:'POST',
            body: JSON.stringify(delivery),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})
export const updateDelivery=createAsyncThunk('delivery/updateDelivery', async ({delivery,cid})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/delivery/updateDelivery/${cid}`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(delivery)
        }
    )
    return response.json()
})

export const updateDeliverySubInfo=createAsyncThunk('delivery/updateDeliverySubInfo', async (delivery)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/delivery/updateDeliveryInfo`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(delivery)
        }
    )
    return response.json()
})


export const deleteDelivery=createAsyncThunk('delivery/deleteDelivery', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/delivery/deleteDelivery/${id}`,
        {
            method: 'GET',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const deliveryInitation =createAsyncThunk('delivery/deliveryInitation', async (delev)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/delivery/deliveryInitation`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(delev)
        }
    )
    return response.json()
})

export const deliverySlice=createSlice({
    name:'delivery',
    initialState,
    reducers: {
        changeRegisterStatus: (state) => {
            state.registerstatus = 'failure';
        },
        changeEditStatus: (state) => {
            state.editstatus = 'failure';
        },
        changeDeleteStatus: (state) => {
            state.deletestatus = 'failure';
        },
    },
    extraReducers:(builder)=>{
        builder
        .addCase(fetchDelivery.pending,(state)=>{
            state.status='loading'
        })
        .addCase(fetchDelivery.fulfilled,(state,action)=>{
            state.status='succeeded'
            state.deliveryList=action.payload
        })
        .addCase(fetchDelivery.rejected,(state,action)=>{
            state.status='failed'
            state.error=action.error.message
        })
            .addCase(fetchDeliveryById.pending,(state)=>{
                state.status='loading'
            })
            .addCase(fetchDeliveryById.fulfilled,(state,action)=>{
                state.status='succeeded'
                state.selectedDelivery=action.payload
            })
            .addCase(fetchDeliveryById.rejected,(state,action)=>{
                state.status='failed'
                state.error=action.error.message
            })
             .addCase(createDelivery.pending,(state)=>{
                state.registerstatus='loading'
            })
            .addCase(createDelivery.fulfilled,(state,action)=>{
                state.registerstatus='succeeded'
                state.deliveryList.push(action.payload)
            })
            .addCase(createDelivery.rejected,(state,action)=>{
                state.registerstatus='failed'
                state.error=action.error.message
            })
             .addCase(updateDelivery.pending,(state)=>{
                state.editstatus='loading'
            })
            .addCase(updateDelivery.fulfilled,(state,action)=>{
                state.editstatus='succeeded'
                const index=state.deliveryList.findIndex(delivery=>delivery.id===action.payload.id)
                if(index!==-1){
                    state.deliveryList[index]=action.payload
                }
            })
            .addCase(updateDelivery.rejected,(state,action)=>{
                state.editstatus='failed'
                state.error=action.error.message
            })
            .addCase(updateDeliverySubInfo.pending,(state)=>{
                state.editstatus='loading'
            })
            .addCase(updateDeliverySubInfo.fulfilled,(state,action)=>{
                state.editstatus='succeeded'
                const index=state.deliveryList.findIndex(delivery=>delivery.id===action.payload.id)
                if(index!==-1){
                    state.deliveryList[index]=action.payload
                }
            })
            .addCase(updateDeliverySubInfo.rejected,(state,action)=>{
                state.editstatus='failed'
                state.error=action.error.message
            })
            .addCase(deliveryInitation.pending,(state)=>{
                state.editstatus='loading'
            })
            .addCase(deliveryInitation.fulfilled,(state,action)=>{
                state.editstatus='succeeded'
                const index=state.deliveryList.findIndex(delivery=>delivery.id===action.payload.id)
                if(index!==-1){
                    state.deliveryList[index]=action.payload
                }
            })
            .addCase(deliveryInitation.rejected,(state,action)=>{
                state.editstatus='failed'
                state.error=action.error.message
            })
             .addCase(deleteDelivery.pending,(state)=>{
                state.deletestatus='loading'
            })
            .addCase(deleteDelivery.fulfilled,(state,action)=>{
                state.deletestatus='succeeded'
                state.deliveryList=state.deliveryList.filter(delivery=>delivery.id!==action.payload.id)
            })
            .addCase(deleteDelivery.rejected,(state,action)=>{
                state.deletestatus='failed'
                state.error=action.error.message
            })
    }
})
export default deliverySlice.reducer;